module.exports = __webpack_public_path__ + "static/img/user.3aac9bec.png";